
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getRemoveAttendeeDtoFormGroup() {
return new FormGroup({
    eventId: new FormControl<string | undefined>(''),
    calendarId: new FormControl<string | undefined>(''),
    attendeeEmail: new FormControl<string | undefined>(''),
    secret: new FormControl<string | undefined>(''),
})
;
}
      